module.exports = __webpack_public_path__ + "static/media/main2.8af7ac57.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/bizhengImg/main2.png
// module id = 1866
// module chunks = 1